<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo" style="z-index: 999;">
        <vuexy-logo class="" style="transform: scale(1.5)"/>
        <h2 class="brand-text text-primary ml-2 mt-25" style="color: white !important;">{{$t('warehouse_management_system')}}</h2>
      </b-link>

      <b-col lg="8" class="d-none d-lg-flex align-items-end p-0 bg-auth h-100 w-100">
        <div class="h-100 w-100 d-lg-flex align-items-center justify-content-center">
          <b-img :src="imgUrl" alt="Login V2" class="bgImg w-100 h-100" style="object-fit: cover;"/>
        </div>
        <div class="auth_overlay"></div>
      </b-col>

      <b-col lg="4" class="auth-bg">
        <locale
          style="
            list-style: none;
            position: absolute;
            top: 20px;
            right: 80px;
            z-index: 1;
          "
          @updateLocale="changeLocale"
        />
        <b-row class="d-flex align-items-center px-2 h-100">
          <b-col sm="8" md="6" lg="12" class="px-5">
            <b-card-title title-tag="h2" class="font-weight-bold mb-1">
              {{$t('others.authorization')}}
            </b-card-title>
            <b-card-text class="mb-2">
              {{$t('welcome_please_login_to_your_account')}}
            </b-card-text>

            <validation-observer ref="loginValidation">
              <b-form class="auth-login-form mt-2" @submit.prevent>
                <b-form-group label="Логин" label-for="login-username">
                  <validation-provider
                    #default="{ errors }"
                    name="Логин"
                    rules="required"
                  >
                    <b-form-input
                      id="login-username"
                      v-model="username"
                      :state="errors.length > 0 ? false : null"
                      name="login-username"
                      placeholder="Логин"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group>
                  <div class="d-flex justify-content-between">
                    <label for="login-password">{{$t('user.password')}}</label>
                  </div>
                  <validation-provider
                    #default="{ errors }"
                    name="Пароль"
                    rules="required"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-form-input
                        id="login-password"
                        v-model="password"
                        :state="errors.length > 0 ? false : null"
                        class="form-control-merge"
                        :type="passwordFieldType"
                        name="login-password"
                        placeholder="············"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">
                      {{ errors[0] }}
                    </small>
                  </validation-provider>
                </b-form-group>

                <b-button
                  variant="primary"
                  block
                  :disabled="disableButton"
                  @click="validationForm"
                >
                  {{$t('enter')}}
                </b-button>
              </b-form>
            </validation-observer>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BCardText,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";
import Locale from "@/@core/layouts/components/app-navbar/components/Locale.vue";
import loader from "@/mixins/loader";

import localeLangs from "@/utils/locales";
import { mapActions } from 'vuex';

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    Locale,
    BCardText,
  },
  mixins: [togglePasswordVisibility, loader],
  data() {
    return {
      status: "",
      password: "",
      username: "",
      langs: localeLangs,
      // eslint-disable-next-line global-require
      sideImg: require("@/assets/images/pages/login4.jpg"),
      required,
      email,
      passwordFieldType: 'password',
      disableButton: false,
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      // if (store.state.appConfig.layout.skin === 'dark') {
      //   // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      //   this.sideImg = require('@/assets/images/pages/login-v2.svg')
      //   return this.sideImg
      // }
      return this.sideImg;
    },
  },
  async mounted() {
    // this.changeLocale();
    // await this.$_loaderStart();
  },

  // async beforeRouteLeave(to, from, next) {
  //   await this.$_loaderStop();
  //   next();
  // },
  methods: {
    ...mapActions('users', ['UPDATE_USER']),
    validationForm() {
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          this.disableButton = true
          setTimeout(() => {
            this.disableButton = false
          }, 2000)
          useJwt.login({
              username: this.username,
              password: this.password,
            })
            .then(async (resp) => {
              useJwt.setToken(resp.data.access);
              useJwt.setRefreshToken(resp.data.refresh);
              const { user_data } = resp.data;
              useJwt.setUserData(user_data);
              const ability = [
                {
                  action: "manage",
                  subject: "all",
                  // subject: user_data.is_superuser ? 'all' : user_data.permission,
                },
              ];
              useJwt.setUserAbilities(ability);
              this.$ability.update(ability);

              if (user_data.role.includes("admin")) {
                this.$router.push("/applications/material/");
              } else if (user_data.role.includes("builder")) {
                this.$router.push("/applications/material/");
              } else if (user_data.role.includes("foreman")) {
                this.$router.push("/applications/material/");
              } else if (user_data.role.includes("manager")) {
                this.$router.push("/applications/material/");
              } else if (user_data.role.includes("chief_manager")) {
                this.$router.push("/applications/material/");
              } else if (user_data.role.includes("accountant")) {
                this.$router.push("/agreements");
              } else if (user_data.role.includes("supplier")) {
                this.$router.push("/agreements");
              } else if (user_data.role.includes("chief_supplier")) {
                this.$router.push("/agreements");
              } else if (user_data.role.includes("pto")) {
                this.$router.push("/pto");
              }else if (user_data.role.includes("supervisor")) {
                this.$router.push("/agreements");
              } else if (user_data.role.includes("financier")) {
                this.$router.push("/agreements");
              } else {
                console.log("Error");
              }


              this.changeLocale()



              // if (user_data.language){
              //   this.$i18n.locale = user_data.language;
              // } else{
              //   this.$i18n.locale = 'ru'
              // }
              // localStorage.setItem('lang', this.$i18n.locale);


              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `${this.$t("enter_sysytem")}, ${
                    user_data.username
                  }`,
                  icon: "EditIcon",
                  variant: "success",
                },
              });

            })
            .catch(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('error_login'),
                  icon: "AlertOctagonIcon",
                  variant: "danger",
                },
              });
            });
        }
      });
    },

    async changeLocale() {
      const userData = useJwt.getUserData();
      const { locale } = this.$i18n;
      localize(locale);
      localStorage.setItem('lang', locale);

      if(userData){
        await this.UPDATE_USER({id: userData.id, language: locale});
        // this.$router.go();
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

.auth_overlay{
  background-color: #000;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  opacity: .3;
  z-index: 100;
}
</style>
